import { Component } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation.service';

@Component({
	selector: 'app-changed-privacy-policy-modal',
	standalone: true,
	imports: [IonicModule, TranslateModule],
	templateUrl: './changed-privacy-policy-modal.component.html',
	styleUrl: './changed-privacy-policy-modal.component.scss',
})
export class ChangedPrivacyPolicyModalComponent {
	constructor(
		public modalCtrl: ModalController,
		public navSvc: NavigationService
	) {}

	static async show(modalCtrl: ModalController) {
		const modal = await modalCtrl.create({
			cssClass: 'auto-height short-info',
			component: this,
			componentProps: {},
			mode: 'ios',
			backdropDismiss: false,
		});
		await modal.present();
		const response = await modal.onDidDismiss();

		return response.data;
	}

	async dismiss() {
		await this.modalCtrl.dismiss();
	}
}
